import styled from "styled-components/macro";

export const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 60;
  & > section {
    position: fixed;
    background-color: ${(props) => props.theme.colors.bgBody};
    border-radius: ${(props) => props.theme.sizes.borderRadius};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.5s ease;

    max-height: calc(100vh - 25%);
    overflow-y: auto;
    @media ${(props) => props.theme.media.tablet} {
      max-height: calc(100vh - 25%);
      overflow-y: auto;
    }

    @media ${(props) => props.theme.media.phone} {
      max-height: calc(100vh - 25%);
      overflow-y: auto;
      & > button {
        right: 1.4em !important;
      }
    }

    & > button {
      position: absolute;
      top: 0.5em;
      right: 1em;
      cursor: pointer;
      border: none;
      outline: none;
      margin: 0;
      padding: 0;
      background: transparent;
      font-size: 1rem;
      font-weight: 700;
      color: ${(props) => props.theme.colors.text};
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.2);
      }
    }
  }

  &.show {
    display: block;
  }

  &.hide {
    display: none;
  }
`;
